import React from 'react';

const MetricCard = ({ title, value, percentageChange, unit = '' }) => {
  const isPositive = percentageChange >= 0;

  return (
    <div className="bg-gray-100 rounded-2xl p-4">
      {/* Header with title and arrow icon */}
      <div className="flex items-center justify-between mb-3">
        <div className="text-sm text-gray-600 font-medium">{title}</div>
        <div className="w-4 h-4">
          <svg
            className="w-full h-full text-custom-blue"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M7 17L17 7M17 7H7M17 7V17"
            />
          </svg>
        </div>
      </div>

      {/* Bottom section with value and percentage */}
      <div className="flex items-baseline justify-between">
        <div className="text-xl font-bold text-gray-900 flex items-baseline">
          <span>{typeof value === 'number' ? value.toLocaleString() : value}</span>
          {unit && <span className="text-xl font-normal ml-1">{unit}</span>}
        </div>
        <div className={`text-xs font-medium ${isPositive ? 'text-green-600' : 'text-red-600'}`}>
          {isPositive ? '+' : ''}
          {percentageChange.toFixed(2)}%
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
